<ng-template #headerTemplate>
  <div class="grid-header-row" *ngIf="uiDeptSettings && buAccess">
    <div class="grid-hdr-col hdr-frozen hdr-checkbox">
      <input type="checkbox"
             name="selectAll"
             class="check-all-checkbox-el"
             [checked]="IsSelectAllSelected"
             (change)="onSelectAllRecordsChange()" />
    </div>

    <div class="grid-hdr-col hdr-frozen hdr-contact"
         [ngClass]="query.sortByColumn === 'firstName'?'hdr-grid-col-sorted':''">
      <a [routerLink]=""
         data-sort-column-name="firstName"
         class="sortable-column text-nowrap"
         (click)="onSortByColumn('firstName')">
        CONTACT
        <span class="th-sort">
          <span *ngIf="query.sortByColumn === 'firstName'">
            <i class="fa"
               [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
          </span>
        </span>
      </a>
    </div>

    <ng-container *ngIf="buAccess.department === 'SUBMITTER' || hasTalentDepartment || hasFinanceDepartment || hasPayrollDepartment">
      <div class="grid-hdr-col hdr-scroll ops-dept-hdr-collapse ops-collapsed-bar"
           [ngClass]="uiDeptSettings.isOperationDeptExpanded?'d-none':''">
        <span class=" text-nowrap">
          <i class="fa btn-ops-dept-expand"
             [ngClass]="!uiDeptSettings.isOperationDeptExpanded?'fa-plus-square-o':''"
             (click)="expandDeptColumns('SUBMITTER')"></i>
        </span>
      </div>
      <ng-container>
        <div class="grid-hdr-col hdr-scroll hdr-operation activity-date"
             [ngClass]="query.sortByColumn === 'activityDate'?'hdr-grid-col-sorted':''"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <a [routerLink]=""
             data-sort-column-name="activityDate"
             (click)="onSortByColumn('activityDate')"
             class="sortable-column text-nowrap">
            Dates Worked
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'activityDate'">
                <i class="fa" [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>
        <div class="grid-hdr-col hdr-scroll hdr-operation "
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded"
             [ngClass]="query.sortByColumn === 'daytype'?'hdr-grid-col-sorted':''">
          <a [routerLink]=""
             data-sort-column-name="daytype"
             (click)="onSortByColumn('daytype')"
             class="sortable-column text-nowrap">
            Day Type
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'daytype'">
                <i class="fa"
                   [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>
        <div class="grid-hdr-col hdr-scroll hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <a [ngClass]="query.sortByColumn === 'sport'?'hdr-grid-col-sorted':''"
             [routerLink]=""
             data-sort-column-name="sport"
             (click)="onSortByColumn('sport')"
             class="sortable-column text-nowrap">
            Event/Show
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'sport'">
                <i class="fa"
                   [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>
        <div class="grid-hdr-col hdr-scroll network-list hdr-operation "
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded"
             [ngClass]="query.sortByColumn === 'network'?'hdr-grid-col-sorted':''">
          <a [routerLink]=""
             data-sort-column-name="network"
             (click)="onSortByColumn('network')"
             class="sortable-column text-nowrap">
            Network
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'network'">
                <i class="fa"
                   [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>
        <!--SCOR-15980 Starts-->
        <div class="grid-hdr-col hdr-scroll employee-type-list hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <a [routerLink]=""
             data-sort-column-name="EmployeeType"
             (click)="onSortByColumn('EmployeeType')"
             class="sortable-column text-nowrap"
             [ngClass]="query.sortByColumn === 'EmployeeType'?'hdr-grid-col-sorted':''">
            Employee<br /> TYPE
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'EmployeeType'">
                <i class="fa" [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>
        <!--SCOR-15980 Ends-->
        <div class="grid-hdr-col hdr-scroll workState-list hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <a [routerLink]=""
             data-sort-column-name="workState"
             (click)="onSortByColumn('workState')"
             class="sortable-column text-nowrap"
             [ngClass]="query.sortByColumn === 'workState'?'hdr-grid-col-sorted':''">
            Work State
            <span class="th-sort">

              <span *ngIf="query.sortByColumn === 'workState'">
                <i class="fa" [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>

            </span>
          </a>
        </div>
        <div class="grid-hdr-col hdr-scroll payroll-custom-rate hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded"
             [ngClass]="query.sortByColumn === 'rate'?'hdr-grid-col-sorted':''">
          <a [routerLink]=""
             data-sort-column-name="rate"
             (click)="onSortByColumn('rate')"
             class="sortable-column text-nowrap">
            Rate (DAY)
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'rate'">
                <i class="fa" [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>
        <div class="grid-hdr-col hours-worked hdr-scroll hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <span class="text-nowrap">
            Hours<br />Worked
          </span>
        </div>
        <div class="grid-hdr-col hdr-scroll company-code hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <span class=" text-nowrap text-center">
            Company Code
          </span>
        </div>
        <div class="grid-hdr-col hdr-costing hdr-scroll hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <span class="text-nowrap">
            WBSE OR COST CENTER
          </span>
        </div>
        <div class="grid-hdr-col payroll-glaccount hdr-scroll hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <a [routerLink]=""
             data-sort-column-name="GLAccount"
             (click)="onSortByColumn('GLAccount')"
             class="sortable-column text-nowrap"
             [ngClass]="query.sortByColumn === 'GLAccount'?'hdr-grid-col-sorted':''">
            GL ACCOUNT
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'GLAccount'">
                <i class="fa" [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>

        <div class="grid-hdr-col operation-comments hdr-scroll hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <span class="text-nowrap">
            SUBMITTER<br /> COMMENT
          </span>
        </div>
        <div [class.d-none]="(!uiDeptSettings.isOperationDeptExpanded || buAccess.department !== 'SUBMITTER')"
             class="grid-hdr-col hdr-scroll operation-actions hdr-operation"
             [ngClass]="buAccess.department !== 'SUBMITTER'?'d-none':''">
          <!--[class.d-none]="(!uiDeptSettings.isTalentDeptExpanded || buAccess.department !== 'APPROVER') || null"-->
          <span class=" text-nowrap">
            SUBMITTER<br /> ACTION
          </span>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="buAccess.department !== 'SUBMITTER'">
      <div [class.d-none]="uiDeptSettings.isTalentDeptExpanded || !hasTalentDepartment"
           class="grid-hdr-col hdr-scroll talnt-dept-hdr-collapse talnt-collapsed-bar">
        <span class="text-nowrap">
          <i class="fa fa-plus-square-o  btn-talnt-dept-expand"
             (click)="uiDeptSettings.hasApproverAccess && expandDeptColumns('APPROVER')"></i>
        </span>
      </div>
      <ng-container *ngIf="uiDeptSettings.hasApproverAccess">
        <div [class.d-none]="!uiDeptSettings.isTalentDeptExpanded || !hasTalentDepartment"
             class="grid-hdr-col talent-comments hdr-scroll align-center">
          <span class=" text-nowrap">
            APPROVER<br /> COMMENT
          </span>
        </div>
        <div [class.d-none]="(!uiDeptSettings.isTalentDeptExpanded || buAccess.department !== 'APPROVER' || !hasTalentDepartment) || null"
             class="grid-hdr-col talent-actions hdr-scroll">
          <span class="text-nowrap">
            APPROVER<br /> ACTION
          </span>
        </div>
      </ng-container>

      <div [class.d-none]="uiDeptSettings.isFinanceDeptExpanded"
           class="grid-hdr-col hdr-scroll fin-dept-hdr-collapse fin-collapsed-bar">
        <span class=" text-nowrap">
          <i class="fa fa-plus-square-o  btn-fin-dept-expand"
             (click)="uiDeptSettings.hasFinanceAccess && expandDeptColumns('FINANCE')"></i>
        </span>
      </div>

      <ng-container *ngIf="uiDeptSettings.hasFinanceAccess">
        <div [class.d-none]="!uiDeptSettings.isFinanceDeptExpanded"
             class="grid-hdr-col hdr-scroll finance-aftra-custom-percentage hdr-finDept">
          <span class=" text-nowrap" style="width:70px;">
            % AFTRA
          </span>
        </div>
        <div class="grid-hdr-col hdr-scroll finance-aftra-custom-amount hdr-finDept"
             [class.d-none]="!uiDeptSettings.isFinanceDeptExpanded">
          <span class=" text-nowrap">
            AFTRA $
          </span>
        </div>
        <div class="grid-hdr-col hdr-scroll finance-union-code hdr-finDept"
             [class.d-none]="!uiDeptSettings.isFinanceDeptExpanded">
          <span class=" text-nowrap">
            Union Code
          </span>
        </div>
        <div class="grid-hdr-col hdr-scroll finance-comments hdr-finDept"
             [class.d-none]="!uiDeptSettings.isFinanceDeptExpanded">
          <span class=" text-nowrap">
            Finance Comment
          </span>
        </div>
        <div class="grid-hdr-col hdr-scroll finance-action hdr-finDept"
             [class.d-none]="(!uiDeptSettings.isFinanceDeptExpanded || buAccess.department !== 'FINANCE')"
             [ngClass]="buAccess.department !== 'FINANCE'?'d-none':''">
          <span class=" text-nowrap">
            action
          </span>
        </div>
      </ng-container>


      <div [class.d-none]="uiDeptSettings.isPayrollDeptExpanded"
           class="grid-hdr-col hdr-scroll payroll-dept-hdr-collapse payDept-collapsed-bar">
        <span class=" text-nowrap">
          <i class="fa fa-plus-square-o  btn-pay-dept-expand"
             (click)="uiDeptSettings.hasPayrollAccess && expandDeptColumns('PAYROLL')"></i>
        </span>
      </div>

      <ng-container *ngIf="uiDeptSettings.hasPayrollAccess">
        <div class="grid-hdr-col activity-date hdr-scroll hdr-payrollDept hideOnOperationExpand"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded  || uiDeptSettings.isOperationDeptExpanded">
          <span class="text-nowrap">
            Dates Worked
          </span>
        </div>
        <div class="grid-hdr-col hdr-scroll payroll-custom-rate hdr-payrollDept hideOnOperationExpand"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded || uiDeptSettings.isOperationDeptExpanded">
          <span class="text-nowrap">
            Rate (DAY)
          </span>
        </div>
        <div class="grid-hdr-col hours-worked hdr-scroll hdr-payrollDept hideOnOperationExpand"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded || uiDeptSettings.isOperationDeptExpanded">
          <span class="text-nowrap">
            Hours<br />Worked
          </span>
        </div>
        <div class="grid-hdr-col hdr-costing hdr-scroll hdr-payrollDept hideOnOperationExpand"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded || uiDeptSettings.isOperationDeptExpanded">
          <span class="text-nowrap">
            WBSE OR COST CENTER
          </span>
        </div>


        <div class="grid-hdr-col hdr-scroll employee-type-list hdr-payrollDept hideOnOperationExpand"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded || uiDeptSettings.isOperationDeptExpanded">
          <span class="text-nowrap">
            Employee<br /> TYPE
          </span>
        </div>

        <div class="grid-hdr-col payroll-glaccount hdr-scroll hdr-payrollDept hideOnOperationExpand"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded || uiDeptSettings.isOperationDeptExpanded">
          <span class="text-nowrap">
            GL ACCOUNT
          </span>
        </div>
        <div class="grid-hdr-col hdr-scroll payroll-wage-type hdr-payrollDept"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded">
          <span class="text-nowrap">
            Wage Type
          </span>
        </div>
        <div class="grid-hdr-col hdr-scroll payroll-provider hdr-payrollDept"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded"
             [ngClass]="query.sortByColumn === 'PayrollProvider'?'hdr-grid-col-sorted':''">
          <a [routerLink]=""
             data-sort-column-name="PayrollProvider"
             (click)="onSortByColumn('PayrollProvider')"
             class="sortable-column text-nowrap">
            Payroll<br />Provider
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'PayrollProvider'">
                <i class="fa"
                   [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>
        <div class="grid-hdr-col hdr-pay-transactions hdr-scroll hdr-payrollDept"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded">
          <span class="text-nowrap">
            TK Contract Code
          </span>
        </div>
        <div class="grid-hdr-col hdr-pay-transactions hdr-scroll hdr-payrollDept"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded">
          <span class="text-nowrap">
            PAY TRANSACTIONS
          </span>
        </div>
        <div class="grid-hdr-col payroll-wage-schedule hdr-scroll hdr-payrollDept"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded">
          <span class="text-nowrap">
            Wage Schedule
          </span>
        </div>
        <div class="grid-hdr-col payroll-job-code hdr-scroll hdr-payrollDept"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded">
          <span class="text-nowrap">
            JOB CODE
          </span>
        </div>
        <div class="grid-hdr-col timecard-rate hdr-scroll hdr-payrollDept"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded">
          <span class="text-nowrap">
            Timecard<br />Rate
          </span>
        </div>

        <div class="grid-hdr-col payroll-comments hdr-scroll hdr-payrollDept"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded">
          <span class="text-nowrap">
            Payroll Comments
          </span>
        </div>
        <div class="grid-hdr-col hdr-payroll-status hdr-scroll hdr-payrollDept"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded">
          <span class="text-nowrap">


          </span>
        </div>
        <div class="grid-hdr-col payroll-job-code hdr-scroll hdr-payrollDept"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded"
             [ngClass]="buAccess.department !== 'PAYROLL'?'d-none':''">
          <span class="text-nowrap">
            Actions
          </span>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div id="hiddenGridHeader" class="grid-header-row hiddenGridHeader" *ngIf="uiDeptSettings && buAccess" style="visibility:collapse;" >
    <div class="grid-hdr-col hdr-frozen hdr-checkbox">
      <input type="checkbox"
             name="selectAll"
             class="check-all-checkbox-el"
             [checked]="IsSelectAllSelected"
             (change)="onSelectAllRecordsChange()" />
    </div>

    <div class="grid-hdr-col hdr-frozen hdr-contact"
         [ngClass]="query.sortByColumn === 'firstName'?'hdr-grid-col-sorted':''">
      <a [routerLink]=""
         data-sort-column-name="firstName"
         class="sortable-column text-nowrap"
         (click)="onSortByColumn('firstName')">
        CONTACT
        <span class="th-sort">
          <span *ngIf="query.sortByColumn === 'firstName'">
            <i class="fa"
               [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
          </span>
        </span>
      </a>
    </div>

    <ng-container *ngIf="buAccess.department === 'SUBMITTER' || hasTalentDepartment || hasFinanceDepartment || hasPayrollDepartment">
      <div class="grid-hdr-col hdr-scroll ops-dept-hdr-collapse ops-collapsed-bar"
           [ngClass]="uiDeptSettings.isOperationDeptExpanded?'d-none':''">
        <span class=" text-nowrap">
          <i class="fa btn-ops-dept-expand"
             [ngClass]="!uiDeptSettings.isOperationDeptExpanded?'fa-plus-square-o':''"
             (click)="expandDeptColumns('SUBMITTER')"></i>
        </span>
      </div>
      <ng-container>
        <div class="grid-hdr-col hdr-scroll hdr-operation"
             [ngClass]="query.sortByColumn === 'activityDate'?'hdr-grid-col-sorted':''"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <a [routerLink]=""
             data-sort-column-name="activityDate"
             (click)="onSortByColumn('activityDate')"
             class="sortable-column text-nowrap">
            Dates Worked
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'activityDate'">
                <i class="fa" [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>
        <div class="grid-hdr-col hdr-scroll hdr-operation "
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded"
             [ngClass]="query.sortByColumn === 'daytype'?'hdr-grid-col-sorted':''">
          <a [routerLink]=""
             data-sort-column-name="daytype"
             (click)="onSortByColumn('daytype')"
             class="sortable-column text-nowrap">
            Day Type
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'daytype'">
                <i class="fa"
                   [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>
        <div class="grid-hdr-col hdr-scroll hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <a [ngClass]="query.sortByColumn === 'sport'?'hdr-grid-col-sorted':''"
             [routerLink]=""
             data-sort-column-name="sport"
             (click)="onSortByColumn('sport')"
             class="sortable-column text-nowrap">
            Event/Show
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'sport'">
                <i class="fa"
                   [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>
        <div class="grid-hdr-col hdr-scroll hdr-operation "
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded"
             [ngClass]="query.sortByColumn === 'network'?'hdr-grid-col-sorted':''">
          <a [routerLink]=""
             data-sort-column-name="network"
             (click)="onSortByColumn('network')"
             class="sortable-column text-nowrap">
            Network
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'network'">
                <i class="fa"
                   [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>
        <!--SCOR-15980 Starts-->
        <div class="grid-hdr-col hdr-scroll hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <a [routerLink]=""
             data-sort-column-name="EmployeeType"
             (click)="onSortByColumn('EmployeeType')"
             class="sortable-column text-nowrap"
             [ngClass]="query.sortByColumn === 'EmployeeType'?'hdr-grid-col-sorted':''">
            Employee<br /> TYPE
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'EmployeeType'">
                <i class="fa" [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>
        <!--SCOR-15980 Ends-->
        <div class="grid-hdr-col hdr-scroll hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <a [routerLink]=""
             data-sort-column-name="workState"
             (click)="onSortByColumn('workState')"
             class="sortable-column text-nowrap"
             [ngClass]="query.sortByColumn === 'workState'?'hdr-grid-col-sorted':''">
            Work State
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'workState'">
                <i class="fa" [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>
        <div class="grid-hdr-col hdr-scroll hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded"
             [ngClass]="query.sortByColumn === 'rate'?'hdr-grid-col-sorted':''">
          <a [routerLink]=""
             data-sort-column-name="rate"
             (click)="onSortByColumn('rate')"
             class="sortable-column text-nowrap">
            Rate (DAY)
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'rate'">
                <i class="fa" [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>
        <div class="grid-hdr-col hdr-scroll hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <span class="text-nowrap">
            Hours<br />Worked
          </span>
        </div>
        <div class="grid-hdr-col hdr-scroll hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <span class=" text-nowrap text-center">
            Company Code
          </span>
        </div>
        <div class="grid-hdr-col hdr-scroll hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <span class="text-nowrap">
            WBSE OR COST CENTER
          </span>
        </div>
        <div class="grid-hdr-col hdr-scroll hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <a [routerLink]=""
             data-sort-column-name="GLAccount"
             (click)="onSortByColumn('GLAccount')"
             class="sortable-column text-nowrap"
             [ngClass]="query.sortByColumn === 'GLAccount'?'hdr-grid-col-sorted':''">
            GL ACCOUNT
            <span class="th-sort">
              <span *ngIf="query.sortByColumn === 'GLAccount'">
                <i class="fa" [ngClass]="query.reverseSort?'fa-caret-down':'fa-caret-up'"></i>
              </span>
            </span>
          </a>
        </div>

        <div class="grid-hdr-col hdr-scroll hdr-operation"
             [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
          <span class="text-nowrap">
            SUBMITTER<br /> COMMENT
          </span>
        </div>
        <div [class.d-none]="(!uiDeptSettings.isOperationDeptExpanded || buAccess.department !== 'SUBMITTER')"
             class="grid-hdr-col hdr-scroll hdr-operation"
             [ngClass]="buAccess.department !== 'SUBMITTER'?'d-none':''">
          <span class=" text-nowrap">
            SUBMITTER<br /> ACTION
          </span>
        </div>
      </ng-container>
    </ng-container>
     
  </div>
</ng-template>
